import { appConfig } from '../../../config/customization';

export default {
  base: {
    display: 'flex',
    height: 18,
    width: 18,
    backgroundColor: appConfig.colors.green,
    borderRadius: '50%',
    color: appConfig.colors.white,
    border: 0,
    cursor: 'pointer',
    outline: 0
  },
  textBase: {
    fontSize: 14,
    fontWeight: 'bold',
    lineHeight: '16px',
    textAlign: 'center',
    verticalAlign: 'middle',
    transform: 'translateX(-15%)'
  }
};
